import { Link, useLocation } from 'react-router-dom';
import { HiOutlineClipboardList, HiOutlineShieldCheck } from 'react-icons/hi';
import logo from '../asset/icons/logo.svg';

const navLinkClass = (active) =>
  `text-xl font-bold leading-none transition-opacity ${
    active ? 'text-ato-red' : 'text-gray-600 hover:text-ato-red'
  }`;

const actionLinkClass = (active) =>
  `inline-flex items-center justify-center gap-2 h-10 px-4 rounded-lg border text-sm font-semibold transition-colors ${
    active
      ? 'bg-ato-red text-white border-ato-red'
      : 'bg-white text-gray-800 border-gray-200 hover:border-ato-red hover:text-ato-red'
  }`;

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const onDashboard = pathname === '/dashboard' || pathname === '/';
  const onLogs = pathname.startsWith('/ailog');

  return (
    <div className="w-full min-h-screen bg-gray-50/50">
      <header className="sticky top-0 z-30 bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-4 min-h-[56px] md:min-h-[64px]">
            <div className="flex items-center gap-3 md:gap-5 min-w-0">
              <Link to="/dashboard" className="flex items-center gap-2.5 shrink-0" aria-label="SafetyNet home">
                <img className="w-9 h-9 md:w-10 md:h-10" src={logo} alt="" />
                <span className="hidden sm:block text-ato-red font-bold text-[10px] leading-tight tracking-tight whitespace-nowrap">
                  ATO Safety Platform℠
                </span>
              </Link>

              <nav
                className="hidden md:flex items-center gap-5 shrink-0 pl-4 md:pl-6 border-l border-gray-200"
                aria-label="SafetyNet"
              >
                <Link to="/dashboard" className={navLinkClass(onDashboard)}>
                  <span className="inline-flex items-center gap-2">
                    <HiOutlineShieldCheck className="w-5 h-5 shrink-0" aria-hidden />
                    Monitored art
                  </span>
                </Link>
              </nav>
            </div>

            <div className="flex items-center gap-2 shrink-0">
              <Link
                to="/ailog"
                className={actionLinkClass(onLogs)}
                aria-current={onLogs ? 'page' : undefined}
              >
                <HiOutlineClipboardList className="w-5 h-5 shrink-0" aria-hidden />
                <span className="hidden sm:inline">Scan logs</span>
              </Link>
            </div>
          </div>
        </div>
      </header>

      <main className="px-4 md:px-6 lg:px-8 py-6 md:py-8 max-w-7xl mx-auto">
        {children}
      </main>
    </div>
  );
}
